import { render, staticRenderFns } from "./goodsIn.vue?vue&type=template&id=1fbed9cc&scoped=true&"
import script from "./goodsIn.vue?vue&type=script&lang=js&"
export * from "./goodsIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbed9cc",
  null
  
)

export default component.exports